export default {
  props: ['coursework_entry'],
  template: '#gallery_preferences_template',
  computed: {
    isVisible() {
      return _.any(this.coursework_entry.coursework_fields, function (field) {
        return field.gallery;
      });
    },
    description() {
      return this.coursework_entry.description;
    }
  },
  watch: {
    description() {
      this.$parent.descriptionValid = !this.errors.has('description');
    }
  }
};
